import React from "react";
import {ReactSVG} from "react-svg";
import {Input, Popup} from "semantic-ui-react";
import imageRegistry from "../../constants/imageRegistry";
import {style} from "../Home/AccountCar";
import InputHeader from "./InputHeader";
import {useTranslation} from "react-i18next";

const CustomInput = ({
                         value,
                         placeholder,
                         label,
                         onChange,
                         error,
                         type,
                         onClear,
                         containerClass,
                         wantClearIcon = true,
                         isBackgroundWhite = true,
                         CustomPostIcon,
                         customPostIconClick,
                         wantToRenderError = true,
                         inputHeader,
                         fieldData = {},

                     }) => {
    const {t} = useTranslation("home");
    return (
        <div
            className={`${error ? "semantic__input-error" : "semantic__input-form"} ${containerClass || "marginY__medium"}`}
        >
            {label && (
                <p className={`form__label ${error && "error__alert"}`}>
                    {label}{" "}
                    {fieldData?.wantFieldInfoIcon && (
                        <Popup
                            trigger={
                                <ReactSVG
                                    wrapper="span"
                                    className="cursor__pointer"
                                    src={imageRegistry.InfoLogo}
                                />
                            }
                            className="popup__info"
                            style={style}
                            content={fieldData?.infoContent}
                            on="click"
                            hideOnScroll
                            position="top center"
                        />
                    )}{" "}
                </p>
            )}
            <div className="inputHeaderInfoIcon">
                <InputHeader className="inputHeader" title={inputHeader}/>
                {type === "phone" &&
                    <Popup
                        style={{backgroundColor: "black", color: "white"}}
                        content={t('mobileInfoPopup')} trigger={<ReactSVG src={imageRegistry.InfoLogo}/>}/>
                }
            </div>
            <Input
                value={value}
                type={type}
                input={{style: {backgroundColor: isBackgroundWhite ? '#FFFFFF' : '#F0F2F4'}}}
                placeholder={placeholder}
                onChange={onChange}
                icon={
                    wantClearIcon && value ? (
                        <ReactSVG
                            className="icon__absolute"
                            src={imageRegistry.closeLogo}
                            onClick={onClear}
                        />
                    ) : CustomPostIcon ? (
                        <ReactSVG
                            className="icon__absolute"
                            src={CustomPostIcon}
                            onClick={customPostIconClick}
                        />
                    ) : (
                        <div className="icon__absolute"/>
                    )
                }
            />
            {error && wantToRenderError && <p className="error__alert">{error}</p>}
        </div>
    );
};

export default CustomInput;
